import React from "react";
import { DialogTitle } from "@headlessui/react";
import { classes } from "lib/actions/util";

export default function ModalTitle(
  p: React.PropsWithChildren<{
    className?: string;
  }>,
) {
  return (
    <DialogTitle className={classes(p.className || "text-2xl")}>
      {p.children}
    </DialogTitle>
  );
}
